<template>
  <div>
    <access-pin v-if="getShowPinPage" />
    <mobialis-form-with-validation v-else @onValidate="continueForm">
      <div :class="{ 'row justify-content-between': showBlocks }">
        <div :class="{ 'col-sm-7': showBlocks }">
          <ReviewYourResponsesHero v-if="showBlocks"></ReviewYourResponsesHero>
          <MobialisCard v-else class="mb-4">
            <img class="license mb-4" :src="require('@/assets/license.svg')" alt="License" />
            <p>
              {{ $t('message.credit.reviewformCardText') }}
            </p>
          </MobialisCard>
          <mobialis-text-input-editable
            :rules="{ required: true, regex: /^([^0-9]*)$/ }"
            :label="$t('message.common.firstName')"
            v-model="firstName"
            vid="firstName"
            data-cy="firstName"
            :aria-labels="textInputAriaLabels"
          ></mobialis-text-input-editable>
          <mobialis-text-input-editable
            :rules="{ required: true, regex: /^([^0-9]*)$/ }"
            :label="$t('message.common.lastName')"
            v-model="lastName"
            vid="lastName"
            data-cy="lastName"
            :aria-labels="textInputAriaLabels"
          ></mobialis-text-input-editable>
          <mobialis-text-input-editable
            rules="required|length:10"
            :label="$t('message.common.phoneNumber')"
            v-model="phoneNumber"
            vid="phoneNumber"
            placeholder="(   )"
            mask-type="phoneNumber"
            type="tel"
            data-cy="phoneNumber"
            :aria-labels="textInputAriaLabels"
          ></mobialis-text-input-editable>
          <mobialis-text-input-editable
            rules="required|email"
            :label="$t('message.common.emailAddress')"
            v-model="emailAddress"
            vid="emailAddress"
            data-cy="emailAddress"
            type="email"
            :aria-labels="textInputAriaLabels"
          ></mobialis-text-input-editable>
          <mobialis-text-input-editable
            :rules="birthDateValidationRule"
            ref="bd"
            :label="$t('message.credit.birthday')"
            v-model="birthdate"
            vid="birthdate"
            :helper="$t('message.credit.birthdayHelper')"
            mask-type="date"
            :raw="false"
            inputmode="numeric"
            data-cy="birthdate"
            :aria-labels="textInputAriaLabels"
          >
            <!-- TODO: custom mask for birthday? -->
          </mobialis-text-input-editable>
          <mobialis-text-input-editable
            rules="required"
            :label="$t('message.credit.streetAddress')"
            v-model="streetAddress"
            vid="streetaddress"
            data-cy="streetAddress"
            :aria-labels="textInputAriaLabels"
          ></mobialis-text-input-editable>
          <mobialis-text-input-editable
            :label="$t('message.credit.unit#')"
            v-model="unitNumber"
            vid="unitNumber"
            type="number"
            data-cy="unitNumber"
            :aria-labels="textInputAriaLabels"
          ></mobialis-text-input-editable>
          <mobialis-text-input-editable
            rules="required"
            :label="$t('message.common.city')"
            v-model="city"
            vid="city"
            data-cy="city"
            :aria-labels="textInputAriaLabels"
          ></mobialis-text-input-editable>
          <mobialis-selection-input-editable
            rules="required"
            :label="$t('message.common.state')"
            v-model="state"
            vid="state"
            :options="states"
            data-cy="state"
            :aria-labels="textInputAriaLabels"
          ></mobialis-selection-input-editable>
          <mobialis-text-input-editable
            rules="required|length:5"
            :label="$t('message.common.zipCode')"
            v-model="zipCode"
            vid="zipCode"
            data-cy="zipCode"
            mask-type="zipCode"
            :aria-labels="textInputAriaLabels"
          ></mobialis-text-input-editable>
        </div>
        <div v-if="showBlocks" class="col-sm-4 d-none d-sm-block">
          <MobialisCard class="mb-4">
            <img class="license mb-4" :src="require('@/assets/license.svg')" alt="License" />
            <p>
              {{ $t('message.credit.reviewformCardText') }}
            </p>
          </MobialisCard>
        </div>
      </div>
      <mobialis-button type="submit" class="mt-4 mb-1" data-cy="submitReviewForm"
        >{{ $t('message.common.continue') }}
      </mobialis-button>
      <p class="d-flex justify-content-center small my-0">
        {{ $t('message.credit.disclaimer.noAffectScore') }}
      </p>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import log from '@/services/log';
import { stateMixin, formMixin } from '@/mixins';
import ReviewYourResponsesHero from '@/components/credit/hero/ReviewYourResponses.vue';
import AccessPin from '@/components/credit/700Credit/AccessPin.vue';

export default {
  name: 'ReviewFormUS',
  mixins: [stateMixin, formMixin],
  data() {
    return {
      textInputAriaLabels: {
        edit: this.$t('message.common.edit'),
        save: this.$t('message.common.save'),
        cancel: this.$t('message.common.cancel'),
      },
      firstName: '',
      lastName: '',
      emailAddress: '',
      phoneNumber: '',
      birthdate: '',
      streetAddress: '',
      unitNumber: '',
      city: '',
      state: '',
      zipCode: '',
    };
  },
  components: {
    ReviewYourResponsesHero,
    AccessPin,
  },
  mounted() {
    this.firstName = this.$store.state.user.firstName;
    this.lastName = this.$store.state.user.lastName;
    this.emailAddress = this.$store.state.user.emailAddress;
    this.phoneNumber = this.$store.state.user.phoneNumber;
    this.birthdate = this.$store.state.user.birthdate;
    this.streetAddress = this.$store.state.user.streetAddress;
    this.unitNumber = this.$store.state.user.unit;
    this.city = this.$store.state.user.city;
    this.state = this.$store.state.user.state;
    this.zipCode = this.$store.state.user.zipCode;
  },
  methods: {
    ...mapActions('usCredit', ['manage700Flow', 'manageEquifaxFlow']),
    /**
     * On form submit, dispatch 700 Credit flow then update lead
     * @param {boolean} isValid - From form validation provider
     */
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }
      try {
        window.addEventListener('message', this.postMessageHandler, false);
        this.$store.commit('SET_LOADING', true);
        this.$store.commit('user/SET_FIRST_NAME', this.firstName);
        this.$store.commit('user/SET_LAST_NAME', this.lastName);
        this.$store.commit('user/SET_EMAIL_ADDRESS', this.emailAddress);
        this.$store.commit('user/SET_PHONE_NUMBER', this.phoneNumber);
        this.$store.commit('user/SET_BIRTHDATE', this.birthdate);
        this.$store.commit('user/SET_STREET_ADDRESS', this.streetAddress);
        this.$store.commit('user/SET_UNIT', this.unitNumber);
        this.$store.commit('user/SET_CITY', this.city);
        this.$store.commit('user/SET_STATE', this.state);
        this.$store.commit('user/SET_ZIP_CODE', this.zipCode);
        await this.manage700Flow();
        if (!this.getShowPinPage) {
          this.$router.push({
            name: `credit-results-${this.baseRoute}`,
          });
        }
      } catch (error) {
        log('Error in US Credit: ', error);
        this.$router.push({ name: `credit-in-error-${this.baseRoute}` });
      } finally {
        try {
          await this.$store.dispatch('lead/updateLead');
        } catch (err) {
          log('Error in US Credit Review Form - Update Lead: ', err);
          this.$router.push({ name: `credit-in-error-${this.baseRoute}` });
        } finally {
          this.$store.commit('SET_LOADING', false);
        }
      }
    },
    /**
     * Pre-filters events and passes Equifax events to
     * event handler in store
     * @param {event} event - iFrame event
     */
    postMessageHandler(event) {
      if (event.data && event.origin === process.env.VUE_APP_700CREDIT_IFRAME_URL) {
        this.manageEquifaxFlow(event);
      }
    },
  },
  computed: {
    ...mapGetters('usCredit', ['getShowPinPage']),
  },
};
</script>

<style lang="scss" scoped>
.license {
  max-width: 100%;
}
</style>
